/**
 * Silences noisy console output in production builds.
 *
 * Imported for side effects as the very first import in `main.tsx` so it takes
 * effect before any other module runs its own top-level code.
 *
 * `console.error` is deliberately left alone so real failures still surface in
 * the browser and in error reporting. `console.warn` is included because some
 * dependencies warn unconditionally on every mount (recharts logs a
 * "width(-1) and height(-1)" warning for each chart it renders), which drowns
 * out anything worth reading.
 *
 * Build with VITE_DEBUG_LOGS=true to keep the full console in a production
 * build, e.g. when debugging a staging deploy.
 */
const noop = () => {};

if (import.meta.env.PROD && import.meta.env.VITE_DEBUG_LOGS !== 'true') {
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.trace = noop;
  console.warn = noop;
}

export type {};
